import { OffersService } from "./implementations/offers.service";

export default defineNuxtPlugin((nuxtApp) => {
  const offers = new OffersService(
    nuxtApp.$axios,
    nuxtApp.$config.public.sgApiUrl
  );

  return {
    provide: {
        offers: offers,
    },
  };
});